import React from "react";
import { Backdrop, Box, Button, CircularProgress, Dialog, Typography } from "@mui/material";

import Input from "./Input";
import i18n from "i18";

export default class ComponentAbstract extends React.Component {

    toggleStateArray(arrayKey, value, cb) {
        const arr = this.state[arrayKey] || [];

        if (!arr.includes(value))
            arr.push(value);
        else
            arr.splice(arr.indexOf(value), 1);

        this.changeState(arrayKey, arr, cb);

        return arr;
    }

    changeState(key, value, cb) {
        this.setState({ [key]: value }, cb?.apply ? cb : null);
    }

    openEditDialog(key, props = {}) {
        const { title, text, label, onClick, selfProps } = props;
        const pr = selfProps || {};

        this.changeState(key, {
            title,
            text,
            buttons: [{ label: "cancel", variant: "outlined" }, { label, onClick }],
            ...pr
        });
    }

    insertGlobalInput(data, dataCustom = {}) {
        return (<Input data={data} custom={dataCustom} />);
    }

    insertDialog(dialogProps, hideCb) {
        const opened = !!dialogProps;
        const { title, text, buttons } = dialogProps || {};

        const element = (text?.apply ? text() : text) || "";

        return (
            <Dialog
                open={opened}
                onClose={hideCb}
                PaperProps={{
                    sx: {
                        maxWidth: "90vw",
                        backgroundColor: "var(--background-menu)",
                    }
                }}
            >
                <Box className="dialogForm flex column pad20 gap16">
                    <Typography component="span" className="font w500 f20" sx={{ color: "var(--text-color)" }}>{i18n.t(title)}</Typography>
                    <Typography component="div" className="font w300 f18" sx={{ color: "var(--text-color)" }}>{element}</Typography>
                    <Box className="buttons flex end gap24">
                        {(buttons || []).map(({ label, variant, onClick }, i) => {
                            return (
                                <Button
                                    key={i}
                                    sx={{ backgroundColor: "#42C0C7" }}
                                    variant={variant || "contained"}
                                    onClick={() => {
                                        hideCb();

                                        if (onClick?.apply)
                                            onClick();
                                    }}
                                >
                                    {i18n.t(label)}
                                </Button>
                            );
                        })}
                    </Box>
                </Box>
            </Dialog>
        );
    }

    insertLoading(props = {}) {
        return (
            <Backdrop
                sx={{ color: 'var(--blue1)', zIndex: (theme) => theme.zIndex.drawer + 1, ...props }}
                open={true}
            >
                <CircularProgress size={50} thickness={5} color="inherit" />
            </Backdrop>
        );
    }
}